<div *ngIf="source && source != null" #parent [ngSwitch]="contentType" class="w-100"
    style="height: 100%; border-radius: 6px;">
    <ng-container *ngSwitchCase="contentTypes.YTVideo">
        <youtube-player [width]="parent.clientWidth" [height]="700" #player [videoId]="source"
            (stateChange)="onStateChange($event,player)">
        </youtube-player>
    </ng-container>
    <ng-container *ngSwitchCase="contentTypes.Video">
        <div class="d-flex justify-content-center py-3">
            <video style="border-radius: 6px;" [src]="source" #player (timeupdate)="onTimeUpdate(player)" width="60%"
                controls height="60%">
                <!-- <source (error)="error($event)" [src]="source" [type]="'video/'+extension">
            Your browser does not support the video tag. -->
            </video>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="contentTypes.Assessment">
        <div class="w-100 d-flex align-items-end justify-content-start gap-2">
            <button
                *ngIf="(validSession() || !viewOnly) && (session?.result?.status != 'Not Attempted Yet')"
                class="v4-btn-every py-2" (click)="openCertificate()"><i class="pi pi-external-link v4-ml-2"></i>
                {{ (viewOnly ? "Certificate" : "View Certificate") | translator}}</button>
            <button
                *ngIf="(validSession() || !viewOnly) && (session?.result?.attempts == true && session?.result?.status != 'Pass')"
                class="v4-btn-every py-2" (click)="openAttempt()"><i class="pi pi-external-link v4-ml-2"></i>
                {{ (viewOnly ? "Click here to start the exam" : "Preview") | translator}}</button>
            <span *ngIf="viewOnly && (session?.result?.attempts == false || session?.result?.status == 'Pass')">
                {{'Assessment already attempted' | translator}},</span>
            <!-- <span *ngIf="!validSession()">
                {{'assessment date passed'|translator}}
            </span> -->
            <span *ngIf="viewOnly && session?.result?.totalAttempts > 0">
                {{('Status: ' + session?.result?.status) | translator}},</span>
            <span *ngIf="viewOnly && session?.result?.totalAttempts > 0">
                {{'Number Of Attempts' | translator}}: {{session?.result?.totalAttempts}}</span>
            <button class="v4-btn-every py-2" *ngIf="!viewOnly" (click)="openAddQuestion()"><i
                    class="pi pi-external-link v4-ml-2"></i>{{"Add Questions" | translator}}</button>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="contentTypes.Survey">
        <div class="w-100 d-flex align-items-start justify-content-start gap-2">
            <button *ngIf="(validSession() && !session.attempted) || !viewOnly" class="v4-btn-every py-2"
                (click)="openAttempt()" target="_blank"><i class="pi pi-external-link v4-ml-2"></i>
                {{ (viewOnly ? "Click here to start the survey" : "Preview") | translator}}</button>
            <p *ngIf="viewOnly && session.attempted">{{'Survey already attempted' | translator}}</p>
            <!-- <p *ngIf="!validSession()">
                {{'survey date has passed'|translator}}
            </p> -->
            <button class="v4-btn-every py-2" *ngIf="!viewOnly" (click)="openAddQuestion()" target="_blank"><i
                    class="pi pi-external-link v4-ml-2"></i>{{"Add Questions" | translator}}</button>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="contentTypes.Pdf">
        <object [data]="source" type="application/pdf" style="width: 100%; height: 65vh; display: block;
                            border-top: #525659 solid 5px; border-bottom: #525659 solid 5px;">
            <!-- <a target="_blank" [href]="source">{{"Download file" | translator}}</a> -->
        </object>
    </ng-container>
    <ng-container *ngSwitchCase="contentTypes.Doc">
        <div class="d-flex align-items-center justify-content-center flex-column gap-4">
            <span class="pi pi-file-word" style="font-size: 10rem;"></span>
            <a target="_blank" [href]="source">{{"Download file" | translator}}</a>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="contentTypes.Excel">
        <div class="d-flex align-items-center justify-content-center flex-column gap-4">
            <span class="pi pi-file-excel" style="font-size: 10rem;"></span>
            <a target="_blank" [href]="source">{{"Download file" | translator}}</a>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="contentTypes.Image">
        <div class="d-flex justify-content-center py-3">
            <img style="width: 50%; height: 50%;border-radius: 10px;" [src]="source" />
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="contentTypes.Text">
        <div class="d-flex justify-content-center py-3">
            <span style="width: 100%; height: 100%" [innerHTML]="source | safeHTML"></span>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="contentTypes.Unsupported">
        <div class="d-flex align-items-center justify-content-center flex-column gap-4">
            <span class="pi pi-exclamation-triangle" style="font-size: 10rem;"></span>
            <span>{{'Unsupported Type' | translator}}</span>
            <!-- <a target="_blank" [href]="source">{{"Download file" | translator}}</a> -->
        </div>
    </ng-container>
</div>